import { useNavigate } from "react-router-dom";
import { BaseButton } from "./BaseButton";
import { ArrowRight } from "iconsax-react";

interface LinkButtonProps {
  label: string;
  to?: string; // Route path
  onClick?: () => void;
  variant?: "primary" | "secondary" | "ghost";
}

export const LinkButton = ({
  label,
  to,
  onClick,
  variant = "secondary",
}: LinkButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    }
    onClick?.();
  };

  return (
    <BaseButton onClick={handleClick} variant={variant}>
      {label}
      <ArrowRight size={16} color="#FEFEFE" />
    </BaseButton>
  );
};
